import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import cn from 'classnames';
import styles from '../Cells.pcss';
const Cell = ()=>/*#__PURE__*/ _jsxs("div", {
        className: cn(styles.kpiCell, styles.kpiCell_loader, 'col fadingLoader'),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.kpiCell__textPlaceholder
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.kpiCell__textPlaceholder
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.kpiCell__textPlaceholder
            })
        ]
    });
export default /*#__PURE__*/ memo(Cell);
